const ENUM = {
  COLLEGE: 1,
  INTERNSHIP: 2,
  SOCIAL: 3,
};

export default Object.freeze(ENUM);

export const getText = (val) => {
  let s = "";
  switch (val) {
    case ENUM.COLLEGE:
      s = "校园招聘";
      break;
    case ENUM.INTERNSHIP:
      s = "实习计划";
      break;
    case ENUM.SOCIAL:
      s = "社会招聘";
      break;
  }
  return s;
};
